import styled from '@emotion/styled';
import { H1 } from 'ds/components/typography';
import { typographyLineHeightCfg, typographyFontSizeCfg } from 'ds/components/typography/types';


export const AuthenticationInfoHeader = styled(H1.withComponent('div'))(({ theme }) => ({
  color: theme.colors.neutrals.black,
  textAlign: 'center',
  marginTop: theme.spacing(4),
  [theme.media.createObjectMediaQuery({ from: 3 })]: {
    fontSize: `${typographyFontSizeCfg.h1.mobile}px`,
    lineHeight: `${typographyLineHeightCfg.h1.mobile}px`,
  },
}));

export const AuthCodeWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const SkipLink = styled.div`
  margin-top: auto;
  align-self: center;
  font-weight: 500;
  cursor: pointer;
`;
